<template>
  <div class="fetch-documents-button">
    <v-popover
      v-if="!isTenderActive || !isExtensionCredentialsEntered"
      placement="top"
      trigger="hover"
      popoverClass="tender-bottom-nav__nav-tooltip"
      :delay="{ show: 100, hide: 600 }"
    >
      <!-- This id is crucial and is used as a hook for chrome extension. DO NOT CHANGE THIS ID. -->
      <BaseRoundButton
        id="fetch-documents-button"
        ref="fetchDocumentsButton"
        :size="36"
        is-transparent
        icon="file-input"
        disabled
        :aria-label="$t('page.opportunity-details.document-manipulations.fetch-from-seao')"
      />
      <template v-slot:popover>
        <div v-if="!isTenderActive" class="fetch-documents-button__tooltip">
          {{ $t('aloha-extension.active-status-only') }}
        </div>
        <div v-else class="fetch-documents-button__tooltip">
          {{ $t('aloha-extension.no-auth-infos') }}
          <BaseLink @click.native="openAlohaExtensionOptions" class="fetch-documents-button__link">
            {{ $t('aloha-extension.options') }}</BaseLink
          >
        </div>
      </template>
    </v-popover>
    <!-- This component's id is used by our chrome extension -->
    <BaseRoundButton
      v-else
      id="fetch-documents-button"
      ref="fetchDocumentsButton"
      :size="36"
      is-transparent
      icon="file-input"
      :tooltip-text="$t('page.opportunity-details.document-manipulations.fetch-from-seao')"
      tooltipPlacement="top"
      :is-loading="isCurrentOpportunityRunningExtension"
      @click.native="scheduleDownloadTask"
    />
  </div>
</template>

<script>
import BaseLink from '@/components/base/BaseLink';
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'DownloadDocumentsButton',
  components: { BaseLink, BaseRoundButton },
  computed: {
    ...mapGetters('tender', ['tender']),
    ...mapGetters('opportunity', ['opportunity']),
    ...mapGetters('chromeExtension', {
      chromeExtensionTasks: 'tasks',
      isExtensionCredentialsEntered: 'isCredentialsEntered',
    }),
    isTenderActive() {
      return this.tender && this.tender.status === 'active';
    },
    isCurrentOpportunityRunningExtension() {
      return this.chromeExtensionTasks.some(
        (task) => task.type === 'documentsRetrieval' && this.opportunity && task.opportunityId === this.opportunity.id,
      );
    },
  },
  methods: {
    openAlohaExtensionOptions() {
      window.postMessage({ action: 'alohaExtensionOpenOptions' }, '*');
    },
    scheduleDownloadTask() {
      if (!this.opportunity || !this.opportunity.tender || !this.opportunity.tender.source) return;
      window.postMessage(
        {
          action: 'scheduleTask',
          tenderId: this.opportunity.tenderId,
          opportunityId: this.opportunity.id,
          opportunity: this.opportunity,
          targetUrl: this.opportunity.tender.source.url,
        },
        '*',
      );
    },
  },
};
</script>

<style lang="scss">
.fetch-documents-button {
  // Hidden until the extension shows it
  #fetch-documents-button {
    display: none;
  }

  &__tooltip {
    text-align: right;
    display: flex;
    flex-direction: column;
    padding: 4px;
  }

  &__link {
    justify-content: flex-end;
  }
}
</style>
